'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import React from 'react'
import { useRouteError } from 'react-router-dom'

// walrus
import Bugsnag from '@lib/bugsnag'

// lib
import ErrorFallback from './error-fallback'

/* -----------------------------------------------------------------------------
 * RouteError
 *
 * react-router catches anything a route element throws before the boundary
 * above it ever sees it, and its own page is a raw stack trace. This gives
 * those errors the same treatment as the rest.
 * -------------------------------------------------------------------------- */

const RouteError = () => {
  const error = useRouteError() as Error

  React.useEffect(() => {
    console.error('Unhandled route error', error)
    if (error instanceof Error) {
      Bugsnag.notify(error)
    }
  }, [error])

  return <ErrorFallback error={error} />
}

export default RouteError
